import { createContext, ReactNode, useContext } from 'react';

export type WizardLayout = 'inline' | 'stacked';

export const WizardLayoutContext = createContext<WizardLayout>('inline');

export const WizardFields = ({ children }: { children: ReactNode }) => {
	const layout = useContext(WizardLayoutContext);
	return (
		<div className={layout === 'stacked' ? 'd-flex flex-column gap-3' : 'd-flex flex-wrap align-items-center gap-2'}>
			{children}
		</div>
	);
};

type WizardFieldProps = { label: string; width: number | string; children: ReactNode };

export const WizardField = ({ label, width, children }: WizardFieldProps) => {
	const layout = useContext(WizardLayoutContext);
	return layout === 'stacked' ? (
		<div className="w-100">
			<div className="small fw-semibold text-muted mb-1">{label}</div>
			{children}
		</div>
	) : (
		<div style={{ width, maxWidth: '100%' }}>{children}</div>
	);
};
